module.exports = __webpack_public_path__ + "img/HiwaQader-Ashq.c8b0aef4.jpg";